/** Inbox- en context-introkaarten via de gedeelde onboarding-hintwachtrij. */
import { useT } from '@/i18n/useT';
import {
  ONBOARDING_HINT_CONTEXT_INTRO,
  ONBOARDING_HINT_INBOX_INTRO,
} from '@/constants/onboardingHints';
import { ONBOARDING_HINT_QUEUE_PRIORITIES } from '@/features/onboarding/constants/onboardingHintQueue';
import { useRegisterOnboardingQueuedHint } from '@/features/onboarding/context/useRegisterOnboardingQueuedHint';
import { useContextIntroHint } from '@/features/organize/hooks/use-context-intro-hint';
import { useInboxIntroHint } from '@/features/organize/hooks/use-inbox-intro-hint';

const InboxIntroHints = ({ isContextPanelOpen, userId }) => {
  const t = useT();

  const { showHint: showInboxHint, dismissHint: dismissInboxHint } =
    useInboxIntroHint({ userId });
  const { showHint: showContextHint, dismissHint: dismissContextHint } =
    useContextIntroHint({ isContextPanelOpen, userId });

  const inboxTitle = t(
    'onboarding.inboxIntro.title',
    'Hier vul je de details in van taken die nog niet compleet zijn.',
  );
  const inboxBody = t(
    'onboarding.inboxIntro.body',
    'Sleep een taak naar een duur, project of context. Zonder duur telt een taak 15 minuten.',
  );
  const contextTitle = t(
    'onboarding.contextIntro.title',
    'Context is waar of wanneer je iets doet, bijvoorbeeld @thuis of @onderweg.',
  );
  const contextBody = t(
    'onboarding.contextIntro.body',
    'Maak hier een context aan of typ `@context` bij een taak. Daarna kun je taken hierheen slepen.',
  );

  useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_INBOX_INTRO,
    priority: ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_INBOX_INTRO],
    eligible: showInboxHint,
    pending: showInboxHint,
    title: inboxTitle,
    body: inboxBody,
    testId: 'inbox-intro-hint',
    onDismiss: dismissInboxHint,
  });

  useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_CONTEXT_INTRO,
    priority:
      ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_CONTEXT_INTRO],
    eligible: isContextPanelOpen && showContextHint,
    pending: showContextHint,
    title: contextTitle,
    body: contextBody,
    testId: 'context-intro-hint',
    onDismiss: dismissContextHint,
  });

  return null;
};

export default InboxIntroHints;
